<template>
  <div class="bg-gray full-height">
    <div class="container-fluid">
      <div class="row" style="padding-top:20px;">
        <div class="col-sm-5 col-centered">
          <div class="white-panel" style="margin-bottom: 0px;">
            <h1>Admin Login</h1>
            <div class="row" style="margin-top:20px;">
              <div class="col-xs-12 col-sm-12">
                <div class="form-group">
                  <input v-model="email"  v-on:keyup.enter="login" class="form-control" placeholder="Email">
                </div>
                <div class="form-group">
                  <input v-model="password"  v-on:keyup.enter="login" type="password" class="form-control" placeholder="Password">
                </div>
                <div class="form-group">
                  <button v-on:click="login" style="width:100%;" class="btn btn-primary btn-blue">Login</button>
                </div>
                <a href="/">Go Home</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/API/API'
import DashboardFooter from '../nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'

export default {
  name: 'AdminLogin',
  components: {
    DashboardFooter
  },
  data () {
    return {
      api: API,
      nav: Navigator,
      email: '',
      password: ''
    }
  },
  mounted () {
    this.getSession()
  },
  methods: {
    getSession: function() {
      let sessionId = localStorage.ECDsessionid
      if(sessionId){
      }
    },
    storeSession: function(sessionId) {
      localStorage.ECDsessionid = sessionId
      this.nav.goAdmin(this);
    },
    login: function() {
      let self = this
      this.api.loginUser(this.email, this.password)
      .then(function (res) {
        let resData = res.data
        if("error" in resData){
          self.$toasted.show(resData.error, { type: 'error', duration: 2500 })
        }else{
          let user = resData.user
          if(user.isAdmin != 1){
            self.$toasted.show('Your do not have the permission to view this page', { type: 'error', duration: 2500 })
          }else{
            let sessionId = resData.sessionId;
            self.storeSession(sessionId);
          }
        }
      })
      .catch(e => {
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminLogin.vue